import React, { Component } from "react";
import PropTypes from "prop-types";
import "./InterviewAccordion.css";

class InterviewAccordion extends Component {
  renderChildren() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        isAccordion: this.props.isAccordion,
        defaultActiveKey: this.props.defaultActiveKey
      });
    });
  }

  render() {
    return <div className="accordion-wrapper">{this.renderChildren()}</div>;
  }
}

InterviewAccordion.propTypes = {
  title: PropTypes.string
};

export default InterviewAccordion;



// WEBPACK FOOTER //
// ./src/components/Recruiter/InterviewAccordion/InterviewAccordion.js